import { render, staticRenderFns } from "./inviteTrade.vue?vue&type=template&id=0eece330&scoped=true&"
import script from "./inviteTrade.vue?vue&type=script&lang=js&"
export * from "./inviteTrade.vue?vue&type=script&lang=js&"
import style0 from "./inviteTrade.vue?vue&type=style&index=0&id=0eece330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eece330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eece330')) {
      api.createRecord('0eece330', component.options)
    } else {
      api.reload('0eece330', component.options)
    }
    module.hot.accept("./inviteTrade.vue?vue&type=template&id=0eece330&scoped=true&", function () {
      api.rerender('0eece330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/invite/inviteTrade.vue"
export default component.exports